import { JsonPipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { SessionService } from "../app-state-services/session/session.service";
import { environment } from "../../../../environments/environment";
import { ChatBotStyleAndConfig } from "../../modals/style-and-config/style-config";
import { ConfigService } from "../../../common/services/config/config.service";

@Injectable({
  providedIn: "root",
})
export class ResponseStreamService {
  contextInfo: any;
  private subscriptions: Subscription[] = [];
  constructor(
    private sessionService: SessionService, 
    private _configService: ConfigService
  ) {}

  connect(url: string, userQuery: string, tenantCode: string): Observable<any> {
    let intentId = "";
    let conversationContextId = "";
    let ownerId = tenantCode || "";const userMessage = userQuery ?? "";

    this.contextInfo = this.sessionService.getContextInfo();

    if (this.contextInfo != null && this.contextInfo !== "") {
      const contextInfo =  JSON.parse(this.contextInfo);
      this.contextInfo = contextInfo;
      intentId = this.contextInfo?.intentId;
      conversationContextId = this.contextInfo?.conversationContextId;
      if (!ownerId) {
        ownerId = tenantCode;
      }
    } else {
      console.log("Context info is not available.");
    }

    const params = new URLSearchParams({
      intentId,
      userMessage,
      conversationContextId,
      ownerId,
    });
    if (tenantCode) {
      params.set("tenantCode", tenantCode);
    }

    return new Observable((observer) => {
      const eventSource = new EventSource(`${url}?${params.toString()}`);

      eventSource.onmessage = (event) => {
        try {
          const jsonData = JSON.parse(event.data);
          observer.next(jsonData);
          if (jsonData.stop === true) {
            eventSource.close();
          }
        } catch (e: any) {
          observer.error(
            new Error("Failed to parse message as JSON: " + e.message)
          );
        }
      };

      eventSource.onerror = (error: any) => {
        console.error("EventSource error:", {
          message: "Error occurred with EventSource",
          error,
          url,
        });
        observer.error(
          new Error("EventSource error: " + (error.message || "Unknown error"))
        );
      };

      return () => {
        eventSource.close();
      };
    });
  }

  sanitizeQueryParam(param: string): string {
    return encodeURIComponent(param);
  }

  buildQueryString(params: { [key: string]: string }): string {
    return Object.entries(params)
      .map(
        ([key, value]) =>
          `${this.sanitizeQueryParam(key)}=${this.sanitizeQueryParam(value)}`
      )
      .join("&");
  }
}
